export const linkStyles = {
  // Styles for the base style
  baseStyle: {},
  // Styles for the size variations
  sizes: {},
  // Styles for the visual style variations
  variants: {
    hamburger: {
      fontSize: "xl",
      fontWeight: "bold",
    },
  },
  // The default `size` or `variant` values
  defaultProps: {},
};
